module.exports = __webpack_public_path__ + "img/cocos-island.8d316233.svg";